function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.45 9.45003H3.625C3.475 9.45003 3.375 9.55003 3.375 9.70003V10.5C3.375 10.65 3.475 10.75 3.625 10.75H4.45C4.6 10.75 4.7 10.65 4.7 10.5V9.70003C4.7 9.55003 4.6 9.45003 4.45 9.45003Z",
  fill: "#323F4B"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.10015 9.45003H6.27515C6.12515 9.45003 6.02515 9.55003 6.02515 9.70003V10.5C6.02515 10.65 6.12515 10.75 6.27515 10.75H7.10015C7.25015 10.75 7.35015 10.65 7.35015 10.5V9.70003C7.35015 9.55003 7.22515 9.45003 7.10015 9.45003Z",
  fill: "#323F4B"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.72515 9.45003H8.90015C8.75015 9.45003 8.65015 9.55003 8.65015 9.70003V10.5C8.65015 10.65 8.75015 10.75 8.90015 10.75H9.72515C9.87515 10.75 9.97515 10.65 9.97515 10.5V9.70003C9.97515 9.55003 9.87515 9.45003 9.72515 9.45003Z",
  fill: "#323F4B"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.375 9.45003H11.55C11.4 9.45003 11.3 9.55003 11.3 9.70003V10.5C11.3 10.65 11.4 10.75 11.55 10.75H12.375C12.525 10.75 12.625 10.65 12.625 10.5V9.70003C12.625 9.55003 12.5 9.45003 12.375 9.45003Z",
  fill: "#323F4B"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M4.45 12.05H3.625C3.475 12.05 3.375 12.15 3.375 12.3V13.1C3.375 13.25 3.475 13.35 3.625 13.35H4.45C4.6 13.35 4.7 13.25 4.7 13.1V12.3C4.7 12.15 4.6 12.05 4.45 12.05Z",
  fill: "#323F4B"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M7.10015 12.05H6.27515C6.12515 12.05 6.02515 12.15 6.02515 12.3V13.1C6.02515 13.25 6.12515 13.35 6.27515 13.35H7.10015C7.25015 13.35 7.35015 13.25 7.35015 13.1V12.3C7.35015 12.15 7.22515 12.05 7.10015 12.05Z",
  fill: "#323F4B"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M9.72515 12.05H8.90015C8.75015 12.05 8.65015 12.15 8.65015 12.3V13.1C8.65015 13.25 8.75015 13.35 8.90015 13.35H9.72515C9.87515 13.35 9.97515 13.25 9.97515 13.1V12.3C9.97515 12.15 9.87515 12.05 9.72515 12.05Z",
  fill: "#323F4B"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M12.375 12.05H11.55C11.4 12.05 11.3 12.15 11.3 12.3V13.1C11.3 13.25 11.4 13.35 11.55 13.35H12.375C12.525 13.35 12.625 13.25 12.625 13.1V12.3C12.625 12.15 12.5 12.05 12.375 12.05Z",
  fill: "#323F4B"
});
var _ref0 = /*#__PURE__*/React.createElement("path", {
  d: "M14.25 3.9H8.375V3.075C8.95 2.925 9.4 2.375 9.4 1.75C9.4 1 8.775 0.375 8 0.375C7.225 0.375 6.6 1 6.6 1.75C6.6 2.375 7.025 2.9 7.625 3.075V3.9H1.75C1 3.9 0.375 4.525 0.375 5.275V14.25C0.375 15 1 15.625 1.75 15.625H14.25C15 15.625 15.625 15 15.625 14.25V5.275C15.625 4.525 15 3.9 14.25 3.9ZM7.35 1.75C7.35 1.4 7.625 1.125 8 1.125C8.35 1.125 8.65 1.4 8.65 1.75C8.65 2.1 8.375 2.375 8 2.375C7.65 2.375 7.35 2.075 7.35 1.75ZM1.75 4.65H14.25C14.6 4.65 14.875 4.925 14.875 5.275V7.125H1.125V5.275C1.125 4.925 1.4 4.65 1.75 4.65ZM14.25 14.875H1.75C1.4 14.875 1.125 14.6 1.125 14.25V7.875H14.875V14.25C14.875 14.6 14.6 14.875 14.25 14.875Z",
  fill: "#323F4B"
});
function SvgIconCalendario(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref0);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendario);
export default __webpack_public_path__ + "static/media/icon-calendario.a37c3de1cd398930001de7881180cf07.svg";
export { ForwardRef as ReactComponent };